import { CS_TAB } from '@/types/cs';
import styled, { css } from 'styled-components';
import ICON_QUESTION from '@/assets/sideBar/question.png';
import CsChat from '@/components/sideNavigation/Cs/chat/CsChat';
import CsHome from '@/components/sideNavigation/Cs/home/CsHome';
import CsResult from '@/components/sideNavigation/Cs/result/CsResult';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';
import ICON_BELL_ON from '@/assets/cs/icon_bell_on.png';
import ICON_BELL_OFF from '@/assets/cs/icon_bell_off.png';
import ICON_CALL from '@/assets/cs/icon_call.png';
import ContactModal from '@/components/sideNavigation/Cs/chat/ContactModal';
import { ReactNode, useState } from 'react';
import useGetCsMessage from '@/hooks/useGetCsMessageAlert';
import { Icon } from '@successmode-ktp/kui';

export const TAB_LIST: {
  value: CS_TAB;
  label: string;
  icon: (fillColor: string) => ReactNode;
}[] = [
  {
    value: 'HOME',
    label: '홈',
    icon: (fillColor) => <Icon.Home size={24} fillColor={fillColor} />,
  },
  {
    value: 'CHAT',
    label: '1:1 문의',
    icon: (fillColor) => <Icon.Chat size={24} fillColor={fillColor} />,
  },
  {
    value: 'RESULT',
    label: '처리 내역',
    icon: (fillColor) => <Icon.History size={24} fillColor={fillColor} />,
  },
];

export const HeaderLeft = (currentTab: CS_TAB) => {
  switch (currentTab) {
    case 'CHAT':
      return '1:1 문의';
    case 'RESULT':
      return '처리 내역';
    default:
      return (
        <>
          <img src={ICON_QUESTION} alt='' width={24} />
          어떤게 필요하세요?
        </>
      );
  }
};

export const HeaderRight = ({ currentTab }: { currentTab: CS_TAB }) => {
  const dispatch = useAppDispatch();
  const { hasTotalCount } = useGetCsMessage();
  const [isOpenContactModal, setIsOpenContactModal] = useState(false);

  const onOpenAlert = () => {
    dispatch(
      updateCs({
        isOpenAlert: true,
      }),
    );
  };

  switch (currentTab) {
    case 'CHAT':
      return (
        <>
          <CallButton onClick={() => setIsOpenContactModal(true)}>
            <img src={ICON_CALL} alt='' width={24} />
          </CallButton>
          <ContactModal
            isOpen={isOpenContactModal}
            onClose={() => setIsOpenContactModal(false)}
          />
        </>
      );
    case 'HOME':
      return (
        <AlertButton onClick={onOpenAlert} hasAlert={hasTotalCount}>
          <img
            src={hasTotalCount ? ICON_BELL_ON : ICON_BELL_OFF}
            alt='알림'
            height={24}
          />
        </AlertButton>
      );
    default:
      return null;
  }
};

const AlertButton = styled.button<{ hasAlert: boolean }>`
  position: relative;
  height: 24px;
  padding: 0;

  ${({ hasAlert }) =>
    hasAlert &&
    css`
      :after {
        content: '새로운 알림이 있습니다';
        position: absolute;
        right: 50%;
        white-space: nowrap;
        padding: 8px 16px;
        border-radius: 6px 0px 6px 6px;
        background: #5f6165;
        box-shadow: 0px 0px 12px 0px rgba(74, 119, 255, 0.12);
        color: #fff;
        font-size: 12px;
        font-weight: 500;
        line-height: 150%;
        animation: slide-down 400ms ease-in-out forwards;
        animation-delay: 200ms;
        opacity: 0;

        @keyframes slide-down {
          0% {
            opacity: 0;
            bottom: calc(-100% - 8px);
          }
          100% {
            opacity: 1;
            bottom: calc(-100% - 14px);
          }
        }
      }
    `}
`;

const CallButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
`;

export const BodyContent = (currentTab: CS_TAB) => {
  switch (currentTab) {
    case 'CHAT':
      return <CsChat />;
    case 'RESULT':
      return <CsResult />;
    default:
      return <CsHome />;
  }
};

const SEND_TYPE = ['TEXT_REQUEST', 'PACKAGE_REQUEST', 'REFUND_CREATE_REQUEST'];
const RECEIVE_TYPE = [
  'ADMIN_TEXT_REQUEST',
  'TEXT_RESPONSE',
  'PACKAGE_ACCEPTED',
  'REFUND_CREATE_ACCEPTED',
  'REFUND_CREATE_REJECTED',
  'REFUND_CREATE_CONFIRMED',
];
export const getChatType = (type: string) => {
  if (RECEIVE_TYPE.includes(type)) {
    return 'RECEIVE';
  }

  return 'SEND';
};

export const ALERT_RENDER_MAP: Record<string, string> = {
  REFUND_CREATE_CONFIRMED: '등록 완료되었습니다',
  REFUND_CREATE_REJECTED: '등록 실패되었습니다',
  REFUND_MODIFY_CONFIRMED: '수정 완료되었습니다',
  REFUND_MODIFY_REJECTED: '수정 실패되었습니다',
  ONE_ON_ONE: '1:1 문의 답변이 도착했습니다',
  PACKAGE_ACCEPTED: '접수 완료되었습니다',
  ADMIN_NOTICE: '고객지원팀에서 메세지가 도착했습니다',
};
